// action types

export const ARTWORK_PAGE_CHANGE = 'ARTWORK_PAGE_CHANGE'
export const ARTWORK_ROWS_PER_PAGE_CHANGE = 'ARTWORK_ROWS_PER_PAGE_CHANGE'

export const SALE_PAGE_CHANGE = 'SALE_PAGE_CHANGE'
export const SALE_ROWS_PER_PAGE_CHANGE = 'SALE_ROWS_PER_PAGE_CHANGE'

export const TOAST_ADD = 'TOAST_ADD'
export const TOAST_DISMISS = 'TOAST_DISMISS'

export const ARTWORK_UPLOADS_ADD = 'ARTWORK_UPLOADS_ADD'
export const ARTWORK_UPLOADS_SHOW_DETAILS = 'ARTWORK_UPLOADS_SHOW_DETAILS'
export const ARTWORK_UPLOADS_HIDE_DETAILS = 'ARTWORK_UPLOADS_HIDE_DETAILS'
export const ARTWORK_UPLOADS_EMPTY = 'ARTWORK_UPLOADS_EMPTY'
export const ARTWORK_UPLOADS_INIT_PROCESSING = 'ARTWORK_UPLOADS_INIT_PROCESSING'
export const ARTWORK_UPLOADS_STOP_PROCESSING = 'ARTWORK_UPLOADS_STOP_PROCESSING'

export const ARTWORK_FILES_RECEIVE = 'ARTWORK_FILES_RECEIVE'
export const ARTWORK_FILES_PROCESSED = 'ARTWORK_FILES_PROCESSED'

// async action types

export const FETCHING = 'FETCHING'
export const FETCHING_ENDED = 'FETCHING_ENDED'

export const LOADING_AUTH_USER = 'LOADING_AUTH_USER'
export const LOADING_AUTH_USER_SUCCEEDED = 'LOADING_AUTH_USER_SUCCEEDED'
export const LOADING_AUTH_USER_FAILED = 'LOADING_AUTH_USER_FAILED'

export const SIGNING_IN = 'SIGNING_IN'
export const SIGNING_IN_SUCCEEDED = 'SIGNING_IN_SUCCEEDED'
export const SIGNING_IN_FAILED = 'SIGNING_IN_FAILED'

export const SIGNING_OUT = 'SIGNING_OUT'
export const SIGNING_OUT_SUCCEEDED = 'SIGNING_OUT_SUCCEEDED'
export const SIGNING_OUT_FAILED = 'SIGNING_OUT_FAILED'

export const SIGNING_UP = 'SIGNING_UP'
export const SIGNING_UP_SUCCEEDED = 'SIGNING_UP_SUCCEEDED'
export const SIGNING_UP_FAILED = 'SIGNING_UP_FAILED'

export const VERIFYING_USER = 'VERIFYING_USER'
export const VERIFYING_USER_SUCCEEDED = 'VERIFYING_USER_SUCCEEDED'
export const VERIFYING_USER_FAILED = 'VERIFYING_USER_FAILED'

export const SENDING_RESET_INSTRUCTIONS =
  'SENDING_RESET_INSTRUCTIONS'
export const SENDING_RESET_INSTRUCTIONS_SUCCEEDED =
  'SENDING_RESET_INSTRUCTIONS_SUCCEEDED'
export const SENDING_RESET_INSTRUCTIONS_FAILED =
  'SENDING_RESET_INSTRUCTIONS_FAILED'

export const REFRESHING_SALES = 'REFRESHING_SALES'
export const REFRESHING_SALES_SUCCEEDED = 'REFRESHING_SALES_SUCCEEDED'
export const REFRESHING_SALES_FAILED = 'REFRESHING_SALES_FAILED'

export const LOADING_USERS = 'LOADING_USERS'
export const LOADING_USERS_SUCCEEDED = 'LOADING_USERS_SUCCEEDED'
export const LOADING_USERS_FAILED = 'LOADING_USERS_FAILED'

export const UPDATING_USER = 'UPDATING_USER'
export const UPDATING_USER_SUCCEEDED = 'UPDATING_USER_SUCCEEDED'
export const UPDATING_USER_FAILED = 'UPDATING_USER_FAILED'

export const UPDATING_USER_PASSWORD = 'UPDATING_USER_PASSWORD'
export const UPDATING_USER_PASSWORD_SUCCEEDED = 'UPDATING_USER_PASSWORD_SUCCEEDED'
export const UPDATING_USER_PASSWORD_FAILED = 'UPDATING_USER_PASSWORD_FAILED'

export const DELETING_USER = 'DELETING_USER'
export const DELETING_USER_SUCCEEDED = 'DELETING_USER_SUCCEEDED'
export const DELETING_USER_FAILED = 'DELETING_USER_FAILED'

export const UPLOADING_PROFILE = 'UPLOADING_PROFILE'
export const UPLOADING_PROFILE_PROGRESS = 'UPLOADING_PROFILE_PROGRESS'
export const UPLOADING_PROFILE_SUCCEEDED = 'UPLOADING_PROFILE_SUCCEEDED'
export const UPLOADING_PROFILE_FAILED = 'UPLOADING_PROFILE_FAILED'

export const LOADING_ARTWORKS = 'LOADING_ARTWORKS'
export const LOADING_ARTWORKS_SUCCEEDED = 'LOADING_ARTWORKS_SUCCEEDED'
export const LOADING_ARTWORKS_FAILED = 'LOADING_ARTWORKS_FAILED'

export const LOADING_ARTWORK_COUNT = 'LOADING_ARTWORK_COUNT'
export const LOADING_ARTWORK_COUNT_SUCCEEDED = 'LOADING_ARTWORK_COUNT_SUCCEEDED'
export const LOADING_ARTWORK_COUNT_FAILED = 'LOADING_ARTWORK_COUNT_FAILED'

export const CREATING_ARTWORK = 'CREATING_ARTWORK'
export const CREATING_ARTWORK_SUCCEEDED = 'CREATING_ARTWORK_SUCCEEDED'
export const CREATING_ARTWORK_FAILED = 'CREATING_ARTWORK_FAILED'

export const UPDATING_ARTWORK = 'UPDATING_ARTWORK'
export const UPDATING_ARTWORK_SUCCEEDED = 'UPDATING_ARTWORK_SUCCEEDED'
export const UPDATING_ARTWORK_FAILED = 'UPDATING_ARTWORK_FAILED'

export const DELETING_ARTWORK = 'DELETING_ARTWORK'
export const DELETING_ARTWORK_SUCCEEDED = 'DELETING_ARTWORK_SUCCEEDED'
export const DELETING_ARTWORK_FAILED = 'DELETING_ARTWORK_FAILED'

export const PUBLISHING_ARTWORK = 'PUBLISHING_ARTWORK'
export const PUBLISHING_ARTWORK_SUCCEEDED = 'PUBLISHING_ARTWORK_SUCCEEDED'
export const PUBLISHING_ARTWORK_FAILED = 'PUBLISHING_ARTWORK_FAILED'

export const UNPUBLISHING_ARTWORK = 'UNPUBLISHING_ARTWORK'
export const UNPUBLISHING_ARTWORK_SUCCEEDED = 'UNPUBLISHING_ARTWORK_SUCCEEDED'
export const UNPUBLISHING_ARTWORK_FAILED = 'UNPUBLISHING_ARTWORK_FAILED'

export const REPLICATING_MARKUPS = 'REPLICATING_MARKUPS'
export const REPLICATING_MARKUPS_SUCCEEDED = 'REPLICATING_MARKUPS_SUCCEEDED'
export const REPLICATING_MARKUPS_FAILED = 'REPLICATING_MARKUPS_FAILED'

export const UPLOADING_ARTWORK = 'UPLOADING_ARTWORK'
export const UPLOADING_ARTWORK_PROGRESS = 'UPLOADING_ARTWORK_PROGRESS'
export const UPLOADING_ARTWORK_SUCCEEDED = 'UPLOADING_ARTWORK_SUCCEEDED'
export const UPLOADING_ARTWORK_FAILED = 'UPLOADING_ARTWORK_FAILED'

export const LOADING_TAGS = 'LOADING_TAGS'
export const LOADING_TAGS_SUCCEEDED = 'LOADING_TAGS_SUCCEEDED'
export const LOADING_TAGS_FAILED = 'LOADING_TAGS_FAILED'

export const LOADING_FRAMETYPES = 'LOADING_FRAMETYPES'
export const LOADING_FRAMETYPES_SUCCEEDED = 'LOADING_FRAMETYPES_SUCCEEDED'
export const LOADING_FRAMETYPES_FAILED = 'LOADING_FRAMETYPES_FAILED'

export const LOADING_SIZES = 'LOADING_SIZES'
export const LOADING_SIZES_SUCCEEDED = 'LOADING_SIZES_SUCCEEDED'
export const LOADING_SIZES_FAILED = 'LOADING_SIZES_FAILED'

export const LOADING_SALES = 'LOADING_SALES'
export const LOADING_SALES_SUCCEEDED = 'LOADING_SALES_SUCCEEDED'
export const LOADING_SALES_FAILED = 'LOADING_SALES_FAILED'



// WEBPACK FOOTER //
// ./src/redux/actionTypes.js